import { useState } from 'react';
import PropTypes from 'prop-types';
// @mui
import { List, Stack } from '@mui/material';
// locales
import { useLocales } from '../../../locales';
//
import { StyledSubheader } from './styles';
import NavList from './NavList';

// ----------------------------------------------------------------------

NavSectionVertical.propTypes = {
  sx: PropTypes.object,
  data: PropTypes.array,
};

// ... (your imports)

export default function NavSectionVertical({ data, sx, ...other }) {
  const { translate } = useLocales();
  const [expandedAccordion, setExpandedAccordion] = useState(false); // Add state for accordion open state

  // Function to handle accordion toggle
  const handleAccordionToggle = (expanded) => {
    setExpandedAccordion(expanded);
  };

  return (
    <Stack sx={sx} {...other}>
      {data.map((group) => {
        const key = group.subheader || group.items[0].title;

        return (
          <List key={key} disablePadding sx={{ px: 2 }}>
            {group.subheader && (
              <StyledSubheader disableSticky>{`${translate(group.subheader)}`}</StyledSubheader>
            )}

            {group.items.map((list) => (
              <NavList
                key={list.title + list.path}
                data={list}
                depth={1}
                hasChild={!!list.children}
                expanded={expandedAccordion} // Pass the expanded state
                onToggle={handleAccordionToggle} // Pass the toggle handler
              />
            ))}
          </List>
        );
      })}
    </Stack>
  );
}

// ... (rest of the code)
